import { SETTINGS_PATHS } from '@/constants/path-constants';
import { useModalWithPathname } from '@/shared/hooks/useModalWithPathname';

/**
 * This hook is used to manage opening and closing of the Slack meetings modal.
 *
 * It does the following:
 * - When the modal is opened, update pathname to `/setting/connected_apps/slack`
 * - When the modal is closed, update pathname to `/setting/connected_apps`
 * - When the initial page loads and the pathname is `/setting/connected_apps/slack`, open the modal
 */
export function useSlackModal({ onClose }: { onClose?: () => void } = {}) {
  return useModalWithPathname({
    onClose,
    modalOpenPathname: SETTINGS_PATHS.SETTINGS_SLACK,
    modalClosedPathname: SETTINGS_PATHS.SETTINGS_INTEGRATIONS,
    getModalElement: async ({ done }) => {
      const { SlackMeetingsModal } = await import(
        '@/features/account-settings/connected-apps/components/slack/SlackMeetingsModal'
      );
      return (
        <SlackMeetingsModal
          onClose={() => {
            done();
          }}
        />
      );
    },
  });
}
